import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PlanForma from "./components/PlanForma"
import Navegacion from "./components/Navegacion"
import Login from './components/Login';
import PrivateRoutes from './components/PrivateRoutes';
import PartidasLista from './components/PartidasLista';
import PartidaForma from './components/PartidaForma';
import ProveedoresLista from './components/catalogos/ProveedoresLista';
import ProveedorForma from './components/catalogos/ProveedorForma';
import ProyectosInforme from './components/proyecto/ProyectosInforme';
import ProyectosPersonales from './components/proyecto/ProyectosPersonales';
import Fechas from './components/configuracion/Fechas';
import Montos from './components/configuracion/Montos';
import Servicio from './components/servicios/Servicio'
import SolicitudesListado from './components/servicios/SolicitudesListado';
import SolicitudesPersonalesListado from './components/servicios/SolicitudesPersonalesListado';
import { Container } from '@mui/system';
import ProyectoInforme from './components/proyecto/ProyectoInforme';
import EntidadesListado from './components/servicios/EntidadesListado';
import AvisosListado from './components/configuracion/AvisosListado';
import AvisosEntidad from './components/configuracion/AvisosEntidad';
import EntidadesListadoRectoria from './components/servicios/EntidadesListadoRectoria';
import ProyectosEntidad from './components/proyecto/ProyectosEntidad';
import SolicitudesPartida from './components/servicios/SolicitudesPartida';
import Menu from './components/Menu';
import Inicio from './components/Inicio';
import PagosCajaListado from './components/servicios/PagosCajaListado';
import Timer from './components/Timer';
import Saldo from './components/servicios/Saldo';
import SaldosListado from './components/servicios/SaldosListado';
import Tramites from './components/servicios/Tramites';
import TramitesListado from './components/servicios/TramitesListado';
import SolicitudesFacturasListado from './components/servicios/SolicitudesFacturasListado';
import SolicitudesListadoTodas from './components/servicios/SolicitudesListadoTodas';
import SolicitudesListadoGastosViajes from './components/servicios/SolicitudesListadoGastosViajes';
import Videos from './components/Videos';
import Manuales from './components/Manuales';

export default function App() {
  return (
    <BrowserRouter>
      <Navegacion />
      <Timer/>      
      <Container>
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route path='/partidas/' element={<PartidasLista />} />
            <Route path='/partidas/agregar' element={<PartidaForma />} />
            <Route path='/partidas/:id/editar' element={<PartidaForma />} />
            <Route path='/proveedores/' element={<ProveedoresLista />} />
            <Route path='/proveedores/agregar' element={<ProveedorForma />} />
            <Route path='/proveedores/:id/editar' element={<ProveedorForma />} />
            <Route path='/' element={<Inicio />} />
            <Route path='/:planeacion' element={<PlanForma />} />
            <Route path='/proyectosInforme/:idResponsable/:planeacion' element={<ProyectosInforme />} />
            <Route path='/proyectosEntidad/:idPlan' element={<ProyectosEntidad />} />
            <Route path='/proyectoInforme/:idProyecto' element={<ProyectoInforme />} />
            <Route path='/proyectosGestion/:idResponsable' element={<ProyectosPersonales />} />
            <Route path='/configuracionFechas/:idEntidad' element={<Fechas />} />
            <Route path='/configuracionMontos/:idEntidad' element={<Montos />} />
            <Route path='/servicios/:idResponsable' element={<Servicio />} />
            <Route path='/servicios/editar/:idSolicitud/:tipo' element={<Servicio />} />
            <Route path='/seguimientoSolicitudes/tipoCaja' element={<PagosCajaListado />} />
            <Route path='/seguimientoSolicitudes/porPlan/:idPlaneacion' element={<SolicitudesListado />} />
            <Route path='/seguimientoSolicitudes/porPlanViajes/:idPlaneacion' element={<SolicitudesListadoGastosViajes />} />
            <Route path='/seguimientoSolicitudes/todas' element={<SolicitudesListadoTodas />} />
            <Route path='/seguimientoSolicitudes/porPlanFacturas/:idPlaneacion' element={<SolicitudesFacturasListado />} />
            <Route path='/tramites' element={<Tramites />} />
            <Route path='/tramites/tramitesListado' element={<TramitesListado />} />
            <Route path='/saldo' element={<Saldo />} />
            <Route path='/saldo/saldosListado' element={<SaldosListado />} />
            <Route path='/seguimientoSolicitudes/porResponsable/:idSolicitante' element={<SolicitudesPersonalesListado />} />
            <Route path='/seguimientoSolicitudes/porPartida/:idPartida' element={<SolicitudesPartida />} />
            <Route path='/seguimientoSolicitudes/division/:idUsuario' element={<EntidadesListado />} />
            <Route path='/seguimientoSolicitudes/rectoria/:tipo/:idUsuario' element={<EntidadesListadoRectoria />} />
            <Route path='/seguimientoSolicitudes/:tipo/:idUsuario/:idEntidad' element={<EntidadesListadoRectoria />} />
            <Route path='/avisos' element={<AvisosListado />} />
            <Route path='/avisosEntidad' element={<AvisosEntidad />} />
            <Route path='/videos' element={<Videos />} />
            <Route path='/manuales' element={<Manuales />} />

            {/* <Route path='/' element={<PartidasLista />} />
            <Route path='/partidas/agregar' element={<PartidaForma />} />
            <Route path='/partidas/:id/editar' element={<PartidaForma />} /> */}
          </Route>
          <Route path='/serviciosMonitores/:tipo/:matricula/:idInforme/:idUsuario/:tipoDocumento/:idOficio/:idConcepto' element={<Servicio />} />
          <Route path='menu/:idStorage' element={<Menu />} />
          <Route path='/auth/login' element={<Login />} />
        </Routes>
      </Container>
    </BrowserRouter>
  );
}